module.exports = __webpack_public_path__ + "static/flags/CS-f90a8a6c549644f0a59b0cfd5d25407b.gif";